import { createStyles } from "antd-style";

const useStyles = createStyles(({ token }) => {
  return {
    menu: {
      ".anticon": { marginRight: "8px" },
      ".ant-dropdown-menu-item": { minWidth: "160px" },
    },
    right: {
      display: "flex",
      float: "right",
      height: "48px",
      marginLeft: "auto",
      overflow: "hidden",
      [`@media only screen and (max-width: ${token.screenMD}px)`]: {
        position: "absolute",
        top: "0",
        right: "12px",
      },
    },
    model: {
      fontSize: "16px",
      lineHeight: "68px",
      color: "#333",
    },
    action: {
      display: "flex",
      alignItems: "center",
      height: "48px",
      padding: "0 12px",
      cursor: "pointer",
      transition: "all 0.3s",
      ">span": { verticalAlign: "middle" },
      "&:hover": { background: "#252a3d" },
    },
    action1: {
      display: "flex",
      height: "48px",
      marginLeft: "auto",
      overflow: "hidden",
      alignItems: "center",
      padding: "0 8px",
      cursor: "pointer",
      borderRadius: token.borderRadius,
      "&:hover": {
        backgroundColor: token.colorBgTextHover,
      },
    },
    search: {
      padding: "0 12px",
      "&:hover": { background: "transparent" },
      [`@media only screen and (max-width: ${token.screenMD}px)`]: {
        display: "none",
      },
    },
    avatar: {
      marginRight: "8px",
      color: token.colorPrimary,
      verticalAlign: "top",
      background: "rgba(255, 255, 255, 0.85)",
      [`@media only screen and (max-width: ${token.screenMD}px)`]: {
        marginRight: "0",
      },
    },
    "out::before": {
      backgroundColor: "#D90B0B",
    },
    ".ant-divider-vertical": {
      [`@media only screen and (max-width: ${token.screenMD}px)`]: {
        verticalAlign: "unset",
      },
    },
    name: {
      [`@media only screen and (max-width: ${token.screenMD}px)`]: {
        display: "none",
      },
    },
  };
});

export default useStyles;
